import React from "react";
import "../../../src/style/block.scss";
import "./style.scss";

interface IProps {
  title: string | "";
  message: string | "";
}

const ShopNotWorking: React.FC<IProps> = ({ title, message }: IProps) => {
  return (
    <React.Fragment>
      <div className="flex-center flex-column shop-not-working shadow">
        <h3>{title}</h3>
        <article>{message}</article>
      </div>
    </React.Fragment>
  );
};

export default ShopNotWorking;
